/**
 * Content Service
 * Fetches series and pricing data from the backend API
 */

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Fetch all series
 */
export const fetchAllSeries = async () => {
  try {
    const response = await fetch(`${API_URL}/api/content/series`);
    if (!response.ok) throw new Error('Failed to fetch series');
    const data = await response.json();
    return data.series;
  } catch (error) {
    console.error('Error fetching series:', error);
    return null;
  }
};

/**
 * Fetch a specific series by slug
 */
export const fetchSeriesBySlug = async (slug) => {
  try {
    const response = await fetch(`${API_URL}/api/content/series/${slug}`);
    if (!response.ok) {
      if (response.status === 404) return null;
      throw new Error('Failed to fetch series');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching series:', error);
    return null;
  }
};

/**
 * Fetch active series only
 */
export const fetchActiveSeries = async () => {
  try {
    const response = await fetch(`${API_URL}/api/content/series/active`);
    if (!response.ok) throw new Error('Failed to fetch active series');
    const data = await response.json();
    return data.series;
  } catch (error) {
    console.error('Error fetching active series:', error);
    return null;
  }
};

/**
 * Fetch pricing configuration
 */
export const fetchPricingConfig = async () => {
  try {
    const response = await fetch(`${API_URL}/api/content/pricing`);
    if (!response.ok) throw new Error('Failed to fetch pricing');
    return await response.json();
  } catch (error) {
    console.error('Error fetching pricing:', error);
    return null;
  }
};

/**
 * Fetch products for display
 */
export const fetchProducts = async () => {
  try {
    const response = await fetch(`${API_URL}/api/content/pricing/products`);
    if (!response.ok) throw new Error('Failed to fetch products');
    const data = await response.json();
    return data.products;
  } catch (error) {
    console.error('Error fetching products:', error);
    return null;
  }
};
